<template>
	<div id="v-loader-component" class="v-loader__overlay">
		<div class="v-loader__bar-container">
			<div class="v-loader__bar-body"></div>
		</div>
		<div class="v-loader__spinner-container">
			<div class="v-loader__spinner-card">
				<div class="v-loader__spinner">
					<div v-for="_ in [].constructor(10)"></div>
				</div>
				<span class="mt-4">
					{{ this.$root?.translate('general-loader-title') }}
				</span>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import ProfilePageMixin from "../Mixins/ProfilePageMixin";

export default defineComponent({
	name: "VLoader",
	mixins: [ProfilePageMixin],
});
</script>

<style scoped>
.v-loader__spinner div:after,
.v-loader__bar-body {
	background-color: v-bind(primaryColorVar);
}
</style>
